import { createSlice, PayloadAction } from "@reduxjs/toolkit"
import { RootState } from "../store"
import { PanelType } from "../../types"

type AppState = {
  visiblePanel: PanelType | null
  panelContext: { orgId?: string } | null
  staffAiDrawerOpen: boolean
}

const initialState: AppState = {
  visiblePanel: null,
  panelContext: null,
  staffAiDrawerOpen: false
}

const appSlice = createSlice({
  name: "app",
  initialState,
  reducers: {
    setVisiblePanel: (state, action: PayloadAction<PanelType>) => {
      state.visiblePanel = action.payload
    },
    resetVisiblePanel: (state, action) => {
      state.visiblePanel = null
    },
    setPanelContext: (
      state,
      action: PayloadAction<{ orgId?: string } | null>
    ) => {
      state.panelContext = action.payload
    },
    setStaffAiDrawerOpen: (state, action: PayloadAction<boolean>) => {
      state.staffAiDrawerOpen = action.payload
    }
  }
})

const { reducer, actions } = appSlice

export const {
  setVisiblePanel,
  resetVisiblePanel,
  setPanelContext,
  setStaffAiDrawerOpen
} = actions

export const selectVisiblePanel = (state: RootState) => state.app.visiblePanel
export const selectPanelContext = (state: RootState) => state.app.panelContext
export const selectStaffAiDrawerOpen = (state: RootState) =>
  state.app.staffAiDrawerOpen

export default reducer
